import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Group, GroupInput } from '../../entities/group/group';
import { Role } from '../../entities/role/role';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

/**
 * The groups service.
 */
@Injectable()
export class GroupsService {
  constructor(
    private apolloService: ApolloService,
  ) {
  }

  /**
   * updates an group
   * @param groupInput group Input
   * @param callback method
   */
  public updateGroup(groupInput: GroupInput, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_GROUP_MUTATION,
      {
        input: groupInput,
      },
      callback
    );
  }
  /**
   * creates an group
   * @param groupInput group Inout
   * @param callback method
   */
  public createGroup(groupInput: GroupInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_GROUP_MUTATION,
      {
        input: groupInput,
      },
      callback
    );
  }

    /**
   * creates an group
   * @param groupInput group Inout
   * @param callback method
   */
    public deleteGroup(group: Group, callback: any): void {
      this.apolloService.mutateAndExecute(
        fromGraphQl.DELETE_GROUP_MUTATION,
        {
          id: group.id,
        },
        callback
      );
    }

  public getGroups(): Observable<Group[]> {
    return this.apolloService.query<fromGraphQl.GetGroupsResponse>(fromGraphQl.GET_GROUPS_QUERY)
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( Group.createGroups(result.data.getGroups));
        })
      );
  }

  removeRoles(group: Group, rolesToRemove: Role[], callback: () => void) {
    let input = new GroupInput(group);
    // remove the roles
    let roles = group.roles;
    for (let i = 0; i < rolesToRemove.length; i++) {
      roles = roles.filter((role) => role !== rolesToRemove[i].id);
    }
    this.updateGroup(input, callback);
  }

  addRoles(group: Group, rolestoAdd: Role[], callback: () => void) {
    let input = new GroupInput(group);
    // merge the existing roles with the new ones
    let roles = new Array<string>();
    for (let i = 0; i < group.roles.length; i++) {
      roles.push(group.roles[i]);
    }
    for (let i = 0; i < rolestoAdd.length; i++) {
      roles.push(rolestoAdd[i]?.id);
    }
    this.updateGroup(input, callback);
  }

}
